import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { TimeSpan } from 'src/app/shared/helpers/time-span';
import { environment } from 'src/environments/environment';
import { IAssignment, ICreateAssignmentRequest, ISearchAssignmentsRequest, IUpdateAssignmentRequest } from '../models/assignment';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {

  constructor(
    private http: HttpClient,
  ){}

  searchAssignments(request: ISearchAssignmentsRequest){
    return this.http.post<IPagedResults<IAssignment[]>>(
      `${environment.baseUrl}/v1/Assignment/searchAssignments`,
      request
    )
  }

  getAssignment(id: string){
    return this.http.get<IAssignment>(
      `${environment.baseUrl}/v1/Assignment/getAssignment/${id}`
    )
  }

  createAssignment(request: ICreateAssignmentRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/Assignment/createAssignment`,
      request
    )
  }

  updateAssignment(request: IUpdateAssignmentRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/Assignment/updateAssignment/${request.id}`,
      request
    )
  }

  deleteAssignment(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/Assignment/deleteAssignment/${id}`
    )
  }
}
